import store from '@/core/store'
import { setMessagesCountBeforeHidingUI } from '@/core/store/Slices/MessagesSlice'
import {
  markMessageAsRead,
  _getOriginalMessage,
} from '@/app-domains/messages/messages.api'
import boxesService from '../boxes/boxes.service'
import threadsService from '../threads/threads.service'

class MessagesService {
  async markMessageAsRead (messageId, threadId, boxId) {
    boxesService.decreaseUnopenedCountOfBoxBy(boxId, 1)
    threadsService.markMessageOfThreadAsRead(threadId, messageId)
    store.commit(`THREAD:${threadId}:UPDATE:READ`)
    await markMessageAsRead(messageId)
  }

  setLoadedMessagesCountBeforeHidingUI () {
    store.dispatch(setMessagesCountBeforeHidingUI())
  }

  async getOriginalMessage (messageId) {
    const message = await _getOriginalMessage(messageId)
    return message
  }
}

export default new MessagesService()
